"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateUser = exports.deactivateUser = exports.activateUser = exports.getUserAvailableRoles = void 0;
var endpoints_1 = require("Modules/users/api/endpoints");
var axios_1 = __importDefault(require("axios"));
var getUserAvailableRoles = function (userId) {
    return axios_1.default
        .get(endpoints_1.endpoints.getUserAvailableRoles(userId))
        .then(function (res) { return res.data.data; });
};
exports.getUserAvailableRoles = getUserAvailableRoles;
var activateUser = function (id) {
    return axios_1.default.patch(endpoints_1.endpoints.activateUser(id)).then(function (res) { return res.data; });
};
exports.activateUser = activateUser;
var deactivateUser = function (id) {
    return axios_1.default.patch(endpoints_1.endpoints.deactivateUser(id)).then(function (res) { return res.data; });
};
exports.deactivateUser = deactivateUser;
// TODO: UPDATE PAYLOAD TYPE AFTER USER UPDATE TYPINGS ARE UP TO DATE
var updateUser = function (id, payload) {
    return axios_1.default.patch(endpoints_1.endpoints.updateUser(id), payload);
};
exports.updateUser = updateUser;
